import { ROOT_ELEMENT } from '@/composables/configuration/configuration'
import useUiFactory from '@/composables/ui/uiFactory'
import useInitializer from '@/composables/initializer/initializer'

const { reloadHash } = useUiFactory()
reloadHash()
window.addEventListener(
  'hashchange',
  () => {
    reloadHash()
  },
  false
)

const el: Element | null = document.querySelector(ROOT_ELEMENT)
if (el instanceof HTMLElement) {
  el.addEventListener('copy', event => {
    event.stopPropagation()
  })
}

const { initApp, defineWindowFunction } = useInitializer()
defineWindowFunction()
initApp(true)
